import React, { Suspense } from 'react'
import { Route, Navigate } from 'react-router-dom'
import Auth from './Auth'
import Admin from './Admin'
import Settings from './Settings'
import Accounts from './Accounts'
import Exchange from './Exchange'
import Instant from './Instant'
import Home from './Home'
import Developers from './Developers'
import IntroducingBroker from './IntroducingBroker'
import Referrals from './Referrals'
import Tickets from './Tickets'
import AccountLock from './AccountLock'
import Reports from './Reports'
import History from './History'
const Layout = React.lazy(() => import('./Layout'))

// prettier-ignore
export default (
  <Route>
    {Auth}
    {Admin}
    {Developers}
    {AccountLock}
    <Route element={<Suspense><Layout /></Suspense>}>
      <Route path="/dashboard" element={<Navigate to="/accounts/mywallet" />} />
      {Settings}
      {Accounts}
      {Instant}
      {History}
      {/* {Canny} */}
      {IntroducingBroker}
      {Referrals}
      {Tickets}
      {Reports}
    </Route>
    {Exchange}
    {/* {Pay} */}
    {Home}
  </Route>
)
